(function () {
  function showCookiePreferences(event) {
    const trigger = event.target.closest('[data-cookie-preferences]');
    if (!trigger) return;
    if (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') return;

    event.preventDefault();
    window.privacyBanner.showPreferences();
  }

  document.addEventListener('click', showCookiePreferences);
})();
